import { Injectable } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private rest: RestService) {}

  getMe() {
    return this.rest.get(api.endpoint.me);
  }

  changePassword(data: any) {
    return this.rest.put(api.endpoint.changePassword, data);
  }
}
